import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getBusinessTypes = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.businessTypeList,
    data,
    true
  );
};

export const getBusinessSegments = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.businessSegmentsList,
    data,
    true
  );
};

export const getIndustrySectors = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.industrySectorsList,
    data,
    true
  );
};

export const getCities = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.cityList,
    data,
    true
  );
};

export const getNationalities = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.nationalityList,
    data,
    true
  );
};

